import { createContext, Dispatch, SetStateAction } from 'react';

export const CurrentErrorContext = createContext<[string, Dispatch<SetStateAction<string>>]>([
    '',
    () => {},
]);
